import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import AdminDashboard from "../Layout/AdminDashboard";
import moment from "moment";
import { Spin, Button } from "antd";
import UpdateGenerateAgreementModal from "./UpdateGenerateAgreementModal";

import "../css/view.css";
import toast from "react-hot-toast";

const ViewAgreement = () => {
  const { agreementId } = useParams(); // Extract agreementId from the route
  const [agreementData, setagreementData] = useState(null);
  const [zoom, setZoom] = useState(1); // State to manage zoom level
  const [noteContent, setNoteContent] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [proposalId, setProposalId] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const apiUrl = process.env.REACT_APP_API_URL;

  const navigate = useNavigate();

  const fetch = async () => {
    try {
      const response = await axios.get(
        `${apiUrl}/api/agreement/getAgreementById/${agreementId}`
      );
      setProposalId(response.data.proposalId);
      setagreementData(response.data);
    } catch (error) {
      console.error("Error fetching agreement data:", error);
    }
  };

  useEffect(() => {
    const fetchNoteContent = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/setting/getSetting`);
        console.log("Fetched note content:", response.data);
        const formattedNote = response.data.agreement_note.split("\n");
        setNoteContent(formattedNote);
      } catch (error) {
        console.error("Error fetching note content:", error);
      }
    };

    fetch();
    fetchNoteContent();
  }, [agreementId]);

  const formattedFromDate = agreementData
    ? moment(agreementData.from_date).format("DD/MM/YYYY")
    : "";
  const formattedToDate = agreementData
    ? moment(agreementData.to_date).format("DD/MM/YYYY")
    : "";

  if (!agreementData) {
    return (
      <AdminDashboard>
        <div className="flex justify-center items-center h-screen">
          <Spin />
        </div>
      </AdminDashboard>
    );
  }

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    fetch();
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    fetch();
    setIsModalVisible(false);
  };
  console.log(agreementData);

  const numberOfOutlets = agreementData.outlets?.reduce(
    (acc, item) => acc + item.quantity,
    0
  );
  // console.log(numberOfOutlets);

  const handleDownload = async () => {
    if (downloading) return;

    setDownloading(true);
    const toastId = toast.loading("Please wait, PDF downloading...");
    try {
      const response = await axios.post(
        `${apiUrl}/api/agreement/generateagreement/${agreementId}?download=true`,
        {},
        {
          responseType: "blob",
        }
      );

      // Create blob URL
      const blob = new Blob([response.data], {
        type: "application/pdf",
      });
      // wait for loading 

      const url = window.URL.createObjectURL(blob);

      // Create temp anchor
      const link = document.createElement("a");
      link.href = url;
      link.download = `Agreement_${agreementData?.agreement_number || agreementId}_${agreementData?.fbo_name}.pdf`;

      document.body.appendChild(link);
      link.click();

      // Cleanup
      link.remove();
      window.URL.revokeObjectURL(url);

      toast.success("PDF downloaded successfully", { id: toastId });
    } catch (error) {
      console.error(error);
      toast.error("Failed to download PDF", { id: toastId });
    } finally {
      setDownloading(false);
    }
  };




  // Inject data into HTML template
  const htmlTemplate = `
  <!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Agreement</title>
    <!-- Tailwind CSS -->
    <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet" />
    <style>
        body, html {
            margin: 0;
            padding: 0;
            font-size: 12pt;
        }

        @page {
            size: A4;
            margin: 0;
        }

        html {
            -webkit-print-color-adjust: exact;
            print-color-adjust: exact;
        }

        .container {
            width: 210mm;
            margin: 0 auto;
            box-sizing: border-box;
        }

        .a4 {
            padding: 10mm;
            background: white;
        }

        .content-box {
            position: relative;
            background-image: linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url("data:image/png;base64,{{imageData}}");
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
            background-attachment: local; /* Ties background to the element's content */
            min-height: 297mm; /* A4 height */
            box-sizing: border-box;
        }

        .page-break-before {
            page-break-before: always;
            break-before: page; /* Modern browsers */
        }

        .text-transparent-bg {
            background-color: rgba(255, 255, 255, 0.6);
            color: rgba(0, 0, 0, 0.8);
            padding: 8px;
            border-radius: 4px;
        }

        .header img {
            width: 80px;
            height: 80px;
            object-fit: contain;
        }

        ol.lower-alpha {
            list-style-type: lower-alpha;
        }

        /* Ensure print context handles backgrounds */
        @media print {
            .content-box {
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact;
                background-image: linear-gradient(rgba(255, 255, 255, 0.7), rgba(255, 255, 255, 0.7)), url("/logo2.png");
            }
        }
    </style>
</head>
<body class="bg-white">
    <div class="container a4 text-transparent-bg">
        <!-- Header -->
        <div class="flex p-4 header items-center border-b mb-4">
            <div class="w-1/5">
                <img src="/logo2.png" alt="Unavar Food Inspection Logo" class="header img" />
            </div>
            <div>
                <h1 class="text-xl font-bold text-gray-800">
                    Unavar Food Inspection and Certification Private Limited
                </h1>
            </div>
        </div>

        <!-- Agreement Document -->
        <div class="agreement-document content-box p-4">
            <h1 class="text-2xl font-bold mb-6 text-center">Agreement</h1>
            <div class="agreement-terms">
                <p class="my-4">
                    This Services Agreement (“Agreement”) is made on this day of <strong>${formattedFromDate}</strong> by and between:<br />
                    <strong>M/s. Unavar Food Inspection and Certification Private Limited</strong> (“Inspection Body”), with its principal place of business at <strong>Flat No. F1, First Floor, Door No. 519, MM Illam, MKN Road, Adambakkam Village, Alandur, Chennai – 600016</strong>.<br />
                    And:<br />
                    <strong>${agreementData.fbo_name}</strong>, with respect to the <strong>Food Safety Services at the following address: ${agreementData.address}</strong>, here in after referred to as <strong>Company</strong>.<br />
                    WHEREBY IT IS AGREED AS FOLLOWS:
                </p>

                <ol class="list-decimal list-inside space-y-4">
                    <li>
                        <strong>Scope of Services.</strong>
                        <p class="ml-4">
                            Unavar  Food  Inspection  and  Certification  Private  Limited  shall  provide  services  of <b>${agreementData.outlets[0].description}</b> to  the company which is made part of this agreement. Unavar Food Inspection and Certification Private Limited will provide the services using trained and qualified Inspection personnel only under adequate supervision. Unavar Food Inspection and Certification Private Limited warrants that it will perform the service in a good,  prompt,  professional  manner  with  reasonable  care  and in  compliance  with  auditing  standard, accreditation and statutory requirements. The services are undertaken with maximum safety precautions and to meet highest standards of quality.
                        </p>
                    </li>
                    <li>
                        <strong>Term and Termination.</strong>
                        <p class="ml-4">
                            The  parties  may  thereafter  renew  the  term  of  this  Agreement  upon  mutual written  agreement. <b>Company</b> may terminate this Agreement at any time during the term without any prior written notice without cause, without any termination fee or any other cost, charge or expense of any kind or nature. In  the  event  either  party  breaches  a  provision  of  this  Agreement,  the  non-defaulting  party  may terminate  this  Agreement  with  written  notice.  If  the  impartiality  policy  of  the  auditing  agency  is compromised, then the agreement will be terminated without prior notice. This right of termination is in  addition  to  whatever  rights  the  non-defaulting  party  may  have  herein,  at  law  or  in  equity.  The inspection  body  shall  not  provide  inspection  services  to  the  legal  entity  of  which  it  is  a  part.  If  the client is found to be part of the companies legal entity, it will lead to the termination of the work.
                        </p>
                    </li>
                    <li>
                        <strong>Fee for Services, Payment, Limitation of Liability.</strong>
                        <p class="ml-4">
                            The  Audit  fees is  decided as <b>${agreementData.total_cost}</b> for per <b>${numberOfOutlets}</b> outlet.  This  fee is  decided  on the acceptance  of  proposal/work order  issued  by  the  client.  The  Inspection  Body  submits  an  invoice  prior  to  the  service  execution  as per  the  agreed  amount.  The  Inspection  Body  agrees  to  provide  GST  invoice  as  per  the  government requirements and the same will be filed in the GST portal. The invoice will be paid by the <b>Company</b> within 7 working days of receipt of the invoice. The services are executed once the payment has been done. If there is a delay in payment beyond 45 days from the date of invoice, the Inspection Body will charge simple interest @24% on the outstanding amount and the invoice shall be paid along with the interest.  The  Inspection  Body  will re-submit  a  proposal  for  the  Inspection  to  be  conducted as any proposal is valid only for 30 days from the date it is created.  The Inspection Body agrees that it will be  solely  responsible  for  the  payment  of  all  taxes  related  to  the  Services.  The  company  shall deduct TDS as per the legal norms.
                        </p>
                        <p class="ml-4 mt-2">
                            The Audit  scores or ratings will be provided as per actuals which was observed at the time of Inspection and payment will not be kept on hold irrespective of the ratings provided to the FBO. In Impartiality risk assessment is carried out for such situation and in case if there is such cases where release of payment will be done on the basis of Inspection Results or Ratings Received, such Tenders or Clients will not be taken for audit.
                        </p>
                    </li>
                    <li>
                        <strong>Governing Law and Arbitration.</strong>
                        <p class="ml-4">
                            This Agreement shall be construed under and governed by the laws of India. Not with standing anything to the contrary herein, either party may seek injunctive or equitable relief (including, without limitation, restraining orders and preliminary injunctions) in any court of competent jurisdiction.
                        </p>
                    </li>
                    <li>
                        <strong>Impartiality.</strong>
                        <p class="ml-4">
                            Unavar  Food  Inspection  and  Certification  Private  Limited  shall  act  impartially,  and its  policies  and procedures for certification of persons shall be fair among all FBO’s and shall not restrict certification on  the  grounds  of  undue  financial  or  other  limiting  conditions.  The  Inspection  Body  shall  beresponsible  for  the  impartiality  of  its  certification  and  inspection  activities  and  shall  not  allow commercial,  financial  or  other  pressures  to  compromise  impartiality.  The  corporate  policies  and practices  ensure  that  the  highest  standards  of  integrity  are  applied  to  all  certification  and  inspection body activities. The management system has the necessary procedures, safeguards and tools to ensure that these policies are strictly upheld and enforced. The Audit service will not affect the trade associate with the clients and the quality of the audit will not be based on the trade associate with the clients.
                        </p>
                    </li>
                    <li>
                        <strong>Confidentiality.</strong>
                        <p class="ml-4">
                            This Confidentiality Policy documents the confidentiality and non – disclosure duties and obligations of  the  employees  and  personnel of  UNAVAR  FOOD  INSPECTION AND  CERTIFICATION PRIVATE LIMITED. All information received by or available to <b>UNAVAR FOOD INSPECTION AND CERTIFICATION PRIVATE LIMITED</b>, staff, auditors, contractors  or committee members (in  whatever  format)  received  in  conducting  Inspection  activities,  or  during other  certification activities, or during any dealings with an organization for any other reason shall be regarded as strictly confidential  and  shall  not  be  divulged  to  any  3rd  party  without  the  express  permission  of  the organization or individual concerned. All records will be retained in a secure manner, only accessible to authorized staff via either paper records or password controlled electronic records. Contractors will be limited to accessing information produced by them in conducting an audit. Records will only be made available to organizations who can demonstrate a legitimate (and legal) right to view those records and specifically to Accreditation Bodies. All staff, auditors, contractors, SME and other members will be required   to   agree   to <b>UNAVAR   FOOD   INSPECTION   AND   CERTIFICATION   PRIVATE LIMITED</b>, confidentiality policy and sign a confidentiality agreement. Contractors will also sign an agreement which also contains the responsibility to maintain confidentiality.
                        </p>
                    </li>
                </ol>
            </div>

            <!-- General Instructions -->
                <h2 class="text-lg font-bold my-4 underline">General Instructions</h2>
                <p class="ml-4 mb-4">
                    On signing the above, the Company ensures the following in terms of the inspection execution:
                </p>
                <ol class="ml-6 lower-alpha space-y-2">
                    <li>
                        Makes all necessary arrangements for the conducting the Inspection including providing documents to be audited, access to all processes and areas, records and personnel for the audit.
                    </li>
                    <li>
                        Wherever necessary, permits the presence of QCI observers or trainee auditor/assessors or shadow auditors to  be  a  part  of  the  Inspection  the  accompanying  auditor  will be  observing,  witnessing  and recording the information, interviews and Inspection will be carried forward by the lead auditor.
                    </li>
                    <li>
                        Wherever necessary, permits the presence of other observers or trainee auditor or shadow auditors to  be  a  part of  the  Inspection  from  the  organization.  The  accompanying  auditor  will be  observing, witnessing and recording the information, interviews and Inspection will be carried forward by the lead auditor.
                    </li>
                    <li>
                        Any misleading and unauthorized information given by FBO will lead to lead to Legal Implications.
                    </li>
                    <li>
                        Inspection is  executed as  per  the  Inspection checklist  and  methodology  of  FSSAI Third Party Inspection regulations 2018.
                    </li>
                    <li>
                        <mark>The FEs shall respond with corrective actions for the Major non-conformances and with evidence of closure to the inspection body within 24 hours of conducting the audits in case of major NCs and for minor NC within 15 Days Corrective Actions Plan to be submitted. These Corrective action or Closure evidence should be submitted by FE in format provided by the inspection body.</mark>
                    </li>
                    <li>
                        <mark>Once Client NC report is shared by client and FE acknowledges the Inspection Report, the inspection body shall upload the audit report, with necessary evidences in FSSAI portal in case of FSSAI Third Party audit – Inspection services else the report is shared only to the Client.</mark>
                    </li>
                    <li>
                        The FEs shall inform the HRAA during the contracted period, without delay, in the event of any of the following:
                        <ol class="ml-6 list-decimal mb-0">
  <li>Changes and/or modifications of premises.</li>
  <li>Major changes in internal control measures.</li>
  <li>Major changes in GMP/GHP system as per Schedule IV of FSS (Licensing & Registration) Regulations, 2011.</li>
</ol>

                    </li>
                    <li>
                        Inspection is executed as per the inspection checklist and methodology of FSSAI Third Party Inspection Regulations 2018.
                    </li>
                    <li>
                        The FEs shall respond with corrective actions for major non-conformances and with evidence of closure to the Inspection Body within 24 hours of conducting the inspections in case of major NCs, and for minor NCs within 15 days, a Corrective Action Plan must be submitted. These corrective actions or closure evidence should be submitted by the FE in the format provided by the Inspection Body.
                    </li>
                    <li>
                        Once the Client NC report is shared by the client and the FE acknowledges the Inspection Report, the Inspection Body shall upload the inspection report, with necessary evidence, to the FSSAI portal in case of FSSAI Third Party Inspection services; otherwise, the report is shared only with the Client.
                    </li>
                    <li>
                        Auditors Safety should be ensured in all condition during course of audit by the FBO and there shouldn’t be any situation which becomes a threat to the safety of the auditor.
                    </li>
                </ol>

            <!-- General Terms and Conditions -->
            <div class="page-break-before content-box p-4">
                <h2 class="text-lg font-bold my-4 underline">GENERAL TERMS AND CONDITIONS OF THE AGREEMENT</h2>
                <div class="space-y-4">
                    <h3 class="font-semibold uppercase text-[18px]">ASSIGNMENT</h3>
                    <p>
                        <b>Unavar Food Inspection and Certification Private Limited</b> will not assign this Agreement or any part hereof without the  prior written  consent of Company Manager.  The Company may assign this Agreement  without  the  prior  written  consent  of  Inspection  Body.  This  Agreement  shall  inure  to  the benefit of the parties and permitted successors and assigns.
                    </p>
                    <h3 class="font-semibold uppercase text-[18px]">Language; Entire Agreement; Amendment; Waiver; Partial Invalidity</h3>
                    <p>
                       The  parties  acknowledge  that  this  Agreement  has  been  negotiated,  concluded,  and  executed in  the English language. In the event a translation is prepared of this Agreement in whole or in part for any purpose, the parties agree that the English language version shall control and be determinative as to the purpose and intent of any provision of this Agreement. 
                    </p>
                    <p>
                       This  Agreement  sets  out  the  entire  agreement  between  the  parties  with  respect  to  the  subject  matter herein  and  supersedes  all  prior  agreements  and  understandings,  both  oral  and  written, in  connection with such subject matter.  No amendment to or modification  of or waiver to this  Agreement shall be binding unless made in writing and signed by each of the parties. The parties agree that execution by electronic signature shall have the same force and effect as execution by manual signature. 
                    </p>
                    <p>
                       Neither party's failure to insist on performance of any of the terms and conditions herein, exercise any right or  privilege granted hereunder or enforce  its rights in  the  event  of  a  breach  by  the  other  party or  any  course  of  dealing  or  performance  shall  constitute  a  waiver  of  any  other  right  or  privilege, whether of the same or similar type. 
                    </p>
                    <p>
                       If any part of this Agreement is determined to be invalid or illegal by any court or agency of competent jurisdiction, then that part shall be limited or curtailed to the extent necessary to make such provision valid, and all other remaining terms of this Agreement shall remain in full force and effect.
                    </p>
                    <h3 class="font-semibold uppercase text-[18px]">Notices</h3>
                    <p>
                       Any notice under this Agreement shall be in writing, in English, and delivered by personal delivery or international courier service with package tracking capability and shall be deemed given upon personal delivery or 3 working days after deposit with the courier service. Notices shall be sent to each party’srespective addresses as set out in the Preamble to this Agreement, at the registered address of a party, or  such  address  as  a  party  may  notify  to  the  other  in  writing.  Typical  day-to  day  communications, including  the  placing  of  orders  by <b>Company</b>,  and  the  sending  of  invoices  by <b>Unavar  Food Inspection and Certification Private Limited,</b> may be sent either by email or by hard copy; 
                    </p>
                    <p>
                      however, no notice of breach or termination sent by either party by email will be considered to be effective for any purpose under this Agreement.
                    </p>
                    <h3 class="font-semibold uppercase text-[18px]">Status of Relationship; Third Party Rights</h3>
                    <p>
                      <b>Unavar Food Inspection and Certification Private Limited,</b> is an independent Body and all persons employed to furnish the Services 
                    </p>
                    <p>
                      are employees of Inspection Body and not of <b>Company. Unavar Food Inspection and Certification Private Limited,</b> solely responsible
                    </p>
                    <p>
                      to comply with all applicable laws, including without limitation, those laws affecting its employment status as an independent Body providing Services to the <b>Company</b>. Neither party nor its agents, employees or representatives shall have any authority to bind the other in any contract with any third party. The parties agree that, a person who is not a party to this Agreement shall not have any rights to enforce any term of this Agreement
                    </p>
                    <h3 class="font-semibold uppercase text-[18px]">Confidentiality</h3>
                    <p>
                       The  terms  of  this  Agreement  are  confidential,  and <b>Unavar  Food  Inspection  and  Certification Private Limited,</b>  and <b>Company</b> shall use reasonable efforts to ensure that the terms/information/data are  not  disclosed  to  any  third  party  without  the  prior  written  consent  of  the  other  party,  except  that <b>Company</b> is  permitted  to  share  this  Agreement  with  the   owner  of  the <b>Company</b>. <b>Unavar  Food Inspection  and  Certification  Private  Limited</b>  and <b>Company</b> agree  that  neither  will at  any  time disclose to  any person or  use  for its  own  benefit  or  the  benefit  of  anyone,  the  other party’sConfidential  Information  without the  prior express written  consent of the  other party. <b>Unavar Food Inspection  and  Certification  Private  Limited</b>  and <b>Company</b> shall  ensure  that  all  employees  to whom the other party’s Confidential Information is disclosed take reasonable precautions to safeguard the confidential status of the other party’s Confidential Information. "Confidential Information" shall mean   any   non-public   information   of <b>Company</b> Manager   or <b>Unavar   Food   Inspection   and Certification  Private  Limited</b>  that is  designated as  confidential  or  proprietary,  that  the  other  party knew  or  reasonably  should have  known  was  confidential  or  proprietary,  or  that derives  independent value from not being generally known to the public.
                    </p>
                    <h3 class="font-semibold uppercase text-[18px]">Headings; Counterparts</h3>
                    <p>
                      The headings used in this Agreement are inserted only as a matter of convenience and for reference and in no way define, limit or describe neither the scope of this Agreement nor the intent of any provision thereof.  This  Agreement  may  be  executed  in  any  number  of  counterparts  and  by  facsimile,  each  of which,  when executed and delivered,  will be  deemed to be  an original and  all of which,  when  taken together,  will be  deemed  to be  but one  and  the  same  agreement.  The  parties agree that execution  by electronic  signature  shall   have  the  same  force  and  effect  as  execution by   manual   signature.
                    </p>
                    <h3 class="font-semibold uppercase text-[18px]"><mark>Complaints and Appeals</mark></h3>
                    <p>
                      <mark>
                        The FE can raise audit and auditor relevant complaints and make appeal against the audit findings, compliance and score to the Inspection body by Mail at admin@unavar.com or through Feedback form which is shared in mail or in Physical hard copy within 7 days of completion of Inspection. The Nature of Complaint and Appeal will be reviewed by respective persons if the complaint/ appeal is found relevant necessary corrective actions will be taken and the same will be reverted to the FE.
                      </mark>
                    </p>
                </div>

                <!-- Signature Section -->
                <div class="mt-8">
                    <p class="mb-4">
                        IN WITNESS WHEREOF, the parties here to shall execute this Services Agreement the day and year first above written.
                    </p>
                    <p class="mb-4">Signed for and on behalf of:</p>
                    <h3 class="font-semibold">
                        Unavar Food Inspection and Certification Private Limited (Inspection Body)
                    </h3>
                    <p class="mt-4">____________________</p>
                    <p>Name: Mr. Vivekanand C</p>
                    <p>Title: Executive Director</p>
                    <h3 class="font-semibold mt-8">
                        Signed for and on behalf of the Company (“The Company/Company Owner”) as for ${agreementData.fbo_name} with respect     to the
                    </h3>
                    <p class="mt-4">____________________</p>
                    <p>Name: ____________________</p>
                    <p>Title: ____________________</p>
                </div>
            </div>
        </div>
    </div>
</body>
</html>
  `;

  return (
    <div>
      <AdminDashboard>
        <div className="top-0 z-50 bg-white">
          <div className="mb-10 border shadow-bottom px-4 py-4 flex items-center">
            <span
              onClick={() => navigate(-1)}
              className="cursor-pointer text-3xl mr-4"
            >
              ←
            </span>
            <h2 className="text-xl font-semibold">View Agreement Document</h2>
            <div className="flex ml-auto gap-x-4">
              <Button type="primary" className="ml-auto" onClick={showModal}>
                Edit
              </Button>
              <Button onClick={handleDownload}
                disabled={downloading}
                className={`px-4 py-2 rounded-md text-white bg-blue-600 transition-all
             ${downloading
                    ? "opacity-60 cursor-not-allowed blur-[0.5px]"
                    : "hover:bg-blue-700"
                  }`}
              >
                {downloading ? "Downloading..." : "Download PDF"}
              </Button>
            </div>
          </div>
        </div>

        <>
          <div className="fixed bottom-4 right-4 flex items-center space-x-4  z-10 ">
            <button
              onClick={() =>
                setZoom((prevZoom) => Math.max(prevZoom - 0.1, 0.5))
              }
              className="px-4 py-2 bg-gray-200 border border-gray-400 rounded"
            >
              -
            </button>
            <span className="text-lg">Zoom: {Math.round(zoom * 100)}%</span>
            <button
              onClick={() =>
                setZoom((prevZoom) => Math.min(prevZoom + 0.1, 1.1))
              }
              className="px-4 py-2 bg-gray-200 border border-gray-400 rounded"
            >
              +
            </button>
          </div>

          <div className="flex justify-center">
            <div
              className=""
              style={{
                width: `${793 * zoom}px`, // Adjust width based on zoom
                transform: `scale(${zoom})`,
                transformOrigin: "center", // Center the zoom effect
              }}
            >
              <div dangerouslySetInnerHTML={{ __html: htmlTemplate }} />
            </div>
          </div>
          <UpdateGenerateAgreementModal
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            agreementIds={agreementId}
            proposalId={proposalId}
          />
        </>
      </AdminDashboard>
    </div>
  );
};

export default ViewAgreement;
